import { toast, Slide } from 'react-toastify';

// Function to show toast message
export const showToast = (type, message, options = {}) => {
    toast[type](message, {
        position: 'top-right',
        autoClose: 2000,
        draggable: false,
        pauseOnHover: false,
        transition: Slide,
        className: 'w-[auto]',
        ...options,
    });
};

export const fnOnChange = (pEvent, pState, pSetState, pErrorState, pSetErrorState) => {
    let { name, value } = pEvent.target;

    pSetState({
        ...pState,
        [name]: value,
    });
    if (!!pErrorState[name])
        pSetErrorState({
            ...pErrorState,
            [name]: null,
        });

    /** New Appoointment **/
    if (name === 'marital_status') {
        pSetState(pState => ({ ...pState, ['married_since']: '' }))
    }

}
